import { observer } from 'mobx-react'
import React, { useEffect, useRef, useState } from 'react'
import CountUp from 'react-countup'

export const NumberCountWrapper = observer(
  ({ final, end = '' }: { final: number; end?: string }) => {
    const ref = useRef<any>(null)
    const [loading, setState] = useState(false)
    const [finish, setFinish] = useState(false)
    const [parent, setParent] = useState<any>(null)

    useEffect(() => {
      if (!ref.current) return
      setTimeout(() => {
        const observerTerm = new window.IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              setState(true)
              setParent(entry.target.parentElement)
            }
          },
          {
            root: null,
            threshold: 0.2,
          },
        )
        observerTerm.observe(ref.current)
      }, 100)
    }, [+final])

    useEffect(() => {
      if (!parent) return
      if (finish && loading) {
        parent.classList.add('finish')
      } else parent.classList.remove('finish')
    }, [finish, parent, loading])

    const getCountOfSymbolsAfter = (final: number) => {
      if (!final.toString().includes('.')) return 0
      const str = final.toString().split('.')
      return str[1].length
    }

  
    return (
      <span ref={ref} className="num">
        {loading ? (
          <CountUp
            start={0}
            end={final}
            duration={2}
            separator=" "
            decimals={getCountOfSymbolsAfter(final)}
            decimal="."
            suffix={end}
            prefix=""
            onEnd={() => setFinish(true)}
          ></CountUp>
        ) : (
          <>
            {0}
            {end}
          </>
        )}
      </span>
    )
  },
)
